import React from 'react';

interface EllipsisTextProps {
  text: string;
  className?: string;
  lines?: 1 | 2 | 3;
}

export const EllipsisText: React.FC<EllipsisTextProps> = ({
  text,
  className = '',
  lines = 1,
}) => {
  // Base classes for ellipsis
  const baseClasses = 'overflow-hidden text-ellipsis';

  // Line handling classes
  const lineClasses = {
    1: 'whitespace-nowrap',
    2: 'line-clamp-2',
    3: 'line-clamp-3',
  };

  return (
    <div className={`${baseClasses} ${lineClasses[lines]} ${className}`}>
      {text}
    </div>
  );
};
